import { render, staticRenderFns } from "./MailAdresseModal.vue?vue&type=template&id=72a16884&"
import script from "./MailAdresseModal.vue?vue&type=script&lang=js&"
export * from "./MailAdresseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports